import script from "./UploadContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadContainer.vue?vue&type=script&setup=true&lang=js"

import "./UploadContainer.vue?vue&type=style&index=0&id=0b44b1ea&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b44b1ea"]])

export default __exports__